import { $t } from "~/i18n.js";
import React from "react";
import { Tabs } from "antd";
import { TotalTypes } from "~/components/profile/tabs/TotalTypes.jsx";
import {
  SPLRecencyTable,
  FESRecencyTable,
  FISRecencyTable,
  TMGRecencyTable,
} from "~/components/recency/index.js";
import { BISRecencyTable } from "~/components/recency/BISRecencyTable.jsx";
import { LastUpdated } from "~/components/atom/LastUpdated.jsx";


export const CardTypeTotals = ({ recency, profile }) => {
  return (
    <div className="overviewFlightTab">
      <Tabs
        defaultActiveKey={recency ? "easa" : "gezagvoerder"}
        items={[
          recency && recency.starts >= 0 && {
            key: "easa",
            label: $t("EASA SPL"),
            children: (
              <div style={{ maxHeight: 300, overflowY: "auto" }}>
                <SPLRecencyTable recency={recency} />
                <LastUpdated date_updated={profile.date_updated} />
              </div>
            ),
          },
          recency && recency.tmg_starts && {
            key: "easatmg",
            label: $t("EASA TMG"),
            children: (
              <div style={{ maxHeight: 300, overflowY: "auto" }}>
                <TMGRecencyTable recency={recency} />
                <LastUpdated date_updated={profile.date_updated} />
              </div>
            ),
          },
          recency && recency.bis && {
            key: "easabis",
            label: $t("UK SFCL BI(s)"),
            children: (
              <div style={{ maxHeight: 300, overflowY: "auto" }}>
                <BISRecencyTable recency={recency} />
                <LastUpdated date_updated={profile.date_updated} />
              </div>
            ),
          },
          recency && recency.fis && {
            key: "easafis",
            label: $t("EASA FI(s)"),
            children: (
              <div style={{ maxHeight: 300, overflowY: "auto" }}>
                <FISRecencyTable recency={recency} />
                <LastUpdated date_updated={profile.date_updated} />
              </div>
            ),
          },
          recency && recency.is_fes && {
            key: "easafes",
            label: $t("EASA FE(s)"),
            children: (
              <div style={{ maxHeight: 300, overflowY: "auto" }}>
                <FESRecencyTable recency={recency} />
                <LastUpdated date_updated={profile.date_updated} />
              </div>
            ),
          },
          {
            key: "vluchten",
            label: $t("Vluchten"),
            children: (
              <div style={{ maxHeight: 300, overflowY: "auto" }}>
                <TotalTypes user_id={profile?.id} />
              </div>
            ),
          },
        ].filter(Boolean)}
      />
    </div>
  );
};
